<div class="container">
    <div class="left-panel">
        <div class="background-image">
            <div class="overlay-shape"></div>
        </div>
    </div>

    <div class="right-panel">
        <img src="assets/images/Combo-Block-Light.png" alt="Lumsa Logo" class="logo">
        <div class="content">
            <h2 class="title">{{ 'LUMIA_TITLE' | translate }}</h2>
        </div>

        <ek-card class="login-card" styleClass="p-4">
            <!-- 1. LOGIN -->
            <ng-container *ngIf="!showRecoveryForm && !isNewPasswordRequired">
                <div *ngIf="loginError" class="error-message-field p-error text-center mb-3">
                    <small>{{ loginError }}</small>
                </div>
                <div *ngIf="loginSuccessMessage" class="success-message-field text-center mb-3">
                    <small>{{ loginSuccessMessage }}</small>
                </div>
                <form class="login-form" [formGroup]="loginForm" (ngSubmit)="login()">

                    <div class="form-field mb-4">
                        <ek-input-text
                                id="username"
                                [label]="'LOGIN_PAGE.USERNAME_LABEL' | translate"
                                formControlName="username"
                                autocomplete="off">
                        </ek-input-text>
                    </div>

                    <div class="form-field">
                        <div class="p-field w-full">
                            <p-password
                                    id="password"
                                    formControlName="password"
                                    [toggleMask]="true"
                                    [feedback]="false"
                                    autocomplete="off"
                                    class="w-full"
                                    inputStyleClass="w-full"
                                    placeholder="{{'LOGIN_PAGE.PASSWORD_LABEL' | translate}}">
                            </p-password>
                        </div>
                        <div *ngIf="loginPassword?.invalid && loginPassword?.touched" class="error-message-field">
                            <small *ngIf="loginPassword?.errors?.['required']">{{
                                    'LOGIN_PAGE.ERRORS.PASSWORD_REQUIRED' |
                                        translate
                                }}</small>
                        </div>
                    </div>

                    <div class="login-actions">
                        <div class="recover-link-container">
                            <a href="#" class="recover-link" (click)="toggleRecoveryForm($event)">
                                {{ 'LOGIN_PAGE.RECOVER_PASSWORD_LINK' | translate }}
                            </a>
                        </div>
                        <div class="login-button-container">
                            <ek-button
                                    type="submit"
                                    [label]="isLoading ? 'Accesso in corso...' : ('NAVBAR.LOGIN' | translate)"
                                    [severity]="'success'"
                                    [disabled]="loginForm.invalid || isLoading">
                            </ek-button>
                        </div>
                    </div>
                </form>
            </ng-container>

            <!-- 2. FORCE CHANGE PASSWORD (First Access) -->
            <ng-container *ngIf="isNewPasswordRequired">
                <form class="login-form" [formGroup]="recoveryForm" (ngSubmit)="submitNewPasswordChallenge()">
                    <p>{{ 'LOGIN_PAGE.NEW_PASSWORD_REQUIRED_INSTRUCTION' | translate }}</p>

                    <div *ngIf="newPasswordError" class="error-message-field p-error text-center mb-3">
                        <small>{{ newPasswordError }}</small>
                    </div>

                    <div class="form-field mb-4">
                        <div class="p-field w-full">
                            <p-password
                                    id="new-password"
                                    formControlName="newPassword"
                                    [toggleMask]="true"
                                    autocomplete="new-password"
                                    class="w-full"
                                    inputStyleClass="w-full"
                                    placeholder="{{'LOGIN_PAGE.NEW_PASSWORD_LABEL' | translate}}">
                            </p-password>
                        </div>
                        <div *ngIf="newPassword?.invalid && newPassword?.touched" class="error-message-field">
                            <small *ngIf="newPassword?.errors?.['required']">{{
                                    'LOGIN_PAGE.ERRORS.NEW_PASSWORD_REQUIRED'
                                        | translate
                                }}</small>
                        </div>
                    </div>

                    <div class="form-field">
                        <div class="p-field w-full">
                            <p-password
                                    id="confirm-new-password"
                                    formControlName="confirmNewPassword"
                                    [toggleMask]="true"
                                    [feedback]="false"
                                    autocomplete="new-password"
                                    class="w-full"
                                    inputStyleClass="w-full"
                                    placeholder="{{'LOGIN_PAGE.CONFIRM_NEW_PASSWORD_LABEL' | translate}}">
                            </p-password>
                        </div>
                        <div *ngIf="confirmNewPassword?.invalid && confirmNewPassword?.touched"
                             class="error-message-field">
                            <small *ngIf="confirmNewPassword?.errors?.['required']">{{
                                    'LOGIN_PAGE.ERRORS.CONFIRM_NEW_PASSWORD_REQUIRED'
                                        | translate
                                }}</small>
                        </div>
                        <div *ngIf="recoveryForm.hasError('passwordMismatch') && confirmNewPassword?.dirty"
                             class="error-message-field">
                            <small>{{ 'LOGIN_PAGE.ERRORS.PASSWORDS_MISMATCH' | translate }}</small>
                        </div>
                    </div>

                    <div class="login-actions mt-4">
                        <div class="recover-link-container">
                            <a href="#" class="recover-link" (click)="toggleRecoveryForm($event)">
                                {{ 'LOGIN_PAGE.BACK_TO_LOGIN_LINK' | translate }}
                            </a>
                        </div>
                        <div class="login-button-container">
                            <ek-button
                                    type="submit"
                                    [label]="'LOGIN_PAGE.CHANGE_PASSWORD_BUTTON' | translate"
                                    [severity]="'success'"
                                    [disabled]="recoveryForm.invalid || isLoading">
                            </ek-button>
                        </div>
                    </div>
                </form>
            </ng-container>

            <!-- 3. PASSWORD RECOVERY FLOW -->
            <ng-container *ngIf="showRecoveryForm">

                <!-- 3A. Request Code -->
                <form *ngIf="!codeSent" class="login-form" [formGroup]="recoveryForm"
                      (ngSubmit)="requestPasswordReset()">
                    <p>{{ 'LOGIN_PAGE.REQUEST_CODE_INSTRUCTION' | translate }}</p>

                    <div *ngIf="passwordResetError" class="error-message-field p-error text-center mb-3">
                        <small>{{ passwordResetError }}</small>
                    </div>

                    <div class="form-field mb-4">
                        <ek-input-text
                                id="recovery-username"
                                [label]="'LOGIN_PAGE.USERNAME_LABEL' | translate"
                                formControlName="recoveryUsername"
                                autocomplete="off">
                        </ek-input-text>
                        <div *ngIf="recoveryUsername?.invalid && recoveryUsername?.touched" class="error-message-field">
                            <small *ngIf="recoveryUsername?.errors?.['required']">{{
                                    'LOGIN_PAGE.ERRORS.EMAIL_REQUIRED' |
                                        translate
                                }}</small>
                            <small *ngIf="recoveryUsername?.errors?.['email']">{{
                                    'LOGIN_PAGE.ERRORS.EMAIL_INVALID' |
                                        translate
                                }}</small>
                        </div>
                    </div>
                    <div class="login-actions">
                        <div class="recover-link-container" style="display: flex; flex-direction: column; gap: 8px;">
                            <a href="#" class="recover-link" (click)="toggleRecoveryForm($event)">
                                {{ 'LOGIN_PAGE.BACK_TO_LOGIN_LINK' | translate }}
                            </a>
                            <!-- MODIFICA: Link "Ho già un codice" -->
                            <a href="#" class="recover-link" style="font-size: 0.9em; opacity: 0.8;" (click)="iHaveACode($event)">
                                {{ 'LOGIN_PAGE.LINKS.ALREADY_HAVE_CODE' | translate }}
                            </a>
                        </div>
                        <div class="login-button-container">
                            <ek-button
                                    type="submit"
                                    [label]="'LOGIN_PAGE.REQUEST_CODE_BUTTON' | translate"
                                    [severity]="'success'"
                                    [disabled]="recoveryForm.get('recoveryUsername')?.invalid || isLoading">
                            </ek-button>
                        </div>
                    </div>
                </form>

                <!-- 3B. Submit Code + New Password -->
                <form *ngIf="codeSent" class="login-form" [formGroup]="recoveryForm" (ngSubmit)="submitNewPassword()">
                    <p>{{ 'LOGIN_PAGE.CODE_SENT_INSTRUCTION' | translate }}</p>

                    <div *ngIf="newPasswordError" class="error-message-field p-error text-center mb-3">
                        <small>{{ newPasswordError }}</small>
                    </div>

                    <!-- MODIFICA: Aggiunto campo username anche qui per garantire validità form -->
                    <div class="form-field mb-4">
                        <ek-input-text
                                id="recovery-username-code"
                                [label]="'LOGIN_PAGE.USERNAME_LABEL' | translate"
                                formControlName="recoveryUsername"
                                autocomplete="off">
                        </ek-input-text>
                        <div *ngIf="recoveryUsername?.invalid && recoveryUsername?.touched" class="error-message-field">
                            <small *ngIf="recoveryUsername?.errors?.['required']">{{
                                    'LOGIN_PAGE.ERRORS.EMAIL_REQUIRED' | translate
                                }}</small>
                            <small *ngIf="recoveryUsername?.errors?.['email']">{{
                                    'LOGIN_PAGE.ERRORS.EMAIL_INVALID' | translate
                                }}</small>
                        </div>
                    </div>

                    <div class="form-field mb-4">
                        <ek-input-text
                                id="recovery-code"
                                [label]="'LOGIN_PAGE.CODE_LABEL' | translate"
                                formControlName="recoveryCode"
                                autocomplete="off">
                        </ek-input-text>
                        <div *ngIf="recoveryCode?.invalid && recoveryCode?.touched" class="error-message-field">
                            <small *ngIf="recoveryCode?.errors?.['required']">{{
                                    'LOGIN_PAGE.ERRORS.RECOVERY_CODE_REQUIRED'
                                        | translate
                                }}</small>
                        </div>
                    </div>

                    <div class="form-field mb-4">
                        <div class="p-field w-full">
                            <p-password
                                    id="new-password"
                                    formControlName="newPassword"
                                    [toggleMask]="true"
                                    autocomplete="new-password"
                                    class="w-full"
                                    inputStyleClass="w-full"
                                    placeholder="{{'LOGIN_PAGE.NEW_PASSWORD_LABEL' | translate}}">
                            </p-password>
                        </div>
                        <div *ngIf="newPassword?.invalid && newPassword?.touched" class="error-message-field">
                            <small *ngIf="newPassword?.errors?.['required']">{{
                                    'LOGIN_PAGE.ERRORS.NEW_PASSWORD_REQUIRED'
                                        | translate
                                }}</small>
                        </div>
                    </div>
                    <div class="form-field">
                        <div class="p-field w-full">
                            <p-password
                                    id="confirm-new-password"
                                    formControlName="confirmNewPassword"
                                    [toggleMask]="true"
                                    [feedback]="false"
                                    autocomplete="new-password"
                                    class="w-full"
                                    inputStyleClass="w-full"
                                    placeholder="{{'LOGIN_PAGE.CONFIRM_NEW_PASSWORD_LABEL' | translate}}">
                            </p-password>
                        </div>
                        <div *ngIf="confirmNewPassword?.invalid && confirmNewPassword?.touched"
                             class="error-message-field">
                            <small *ngIf="confirmNewPassword?.errors?.['required']">{{
                                    'LOGIN_PAGE.ERRORS.CONFIRM_NEW_PASSWORD_REQUIRED'
                                        | translate
                                }}</small>
                        </div>
                        <div *ngIf="recoveryForm.hasError('passwordMismatch') && confirmNewPassword?.dirty"
                             class="error-message-field">
                            <small>{{ 'LOGIN_PAGE.ERRORS.PASSWORDS_MISMATCH' | translate }}</small>
                        </div>
                    </div>
                    <div class="login-actions">
                        <div class="recover-link-container">
                            <a href="#" class="recover-link" (click)="toggleRecoveryForm($event)">
                                {{ 'LOGIN_PAGE.BACK_TO_LOGIN_LINK' | translate }}
                            </a>
                        </div>
                        <div class="login-button-container">
                            <ek-button
                                    type="submit"
                                    [label]="'LOGIN_PAGE.CHANGE_PASSWORD_BUTTON' | translate"
                                    [severity]="'success'"
                                    [disabled]="recoveryForm.invalid || isLoading">
                            </ek-button>
                        </div>
                    </div>
                </form>
            </ng-container>
        </ek-card>
    </div>
</div>